import { PROVISIONAL_TOURNAMENT_DETAILS_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { Tournament } from 'core/models/Tournament'

const initialState: { tournament: Tournament | null, isLoading: boolean } = {
  tournament: null,
  isLoading: false
}

interface ActionType extends Action {
  payload: {
    tournament: Tournament;
  }
}

export default function provisionalTournamentDetailsReducer(state = initialState, action: ActionType) {

  switch (action.type) {
    case PROVISIONAL_TOURNAMENT_DETAILS_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case PROVISIONAL_TOURNAMENT_DETAILS_ACTION.SUCCESS:
      const { tournament } = action.payload;
      return { ...state, tournament, isLoading: false }

    case PROVISIONAL_TOURNAMENT_DETAILS_ACTION.FAILURE:
      return { ...state, ...initialState }

    case PROVISIONAL_TOURNAMENT_DETAILS_ACTION.RESET:
      return initialState

    default:
      return state
  }
}